import { Base } from "../../framework/base";
import { IdTitleNode, IIdTitleNode } from "../common/idTitleNode";
import { AppReportTemplateEditItem, IAppReportTemplateEditItem } from "../appReportTemplate/appReportTemplateEditItem";

export interface IAppReportNew {
    unitId: string;
    appReportTemplateId: string;
    units: IIdTitleNode[];
    allAllowedUnits: IIdTitleNode[];
    appReportTemplates: IAppReportTemplateEditItem[];
}

export class AppReportNew implements IAppReportNew {
    unitId: string;
    appReportTemplateId: string;
    units: IdTitleNode[];
    allAllowedUnits: IdTitleNode[];
    appReportTemplates: AppReportTemplateEditItem[];

    constructor();
    constructor(obj: IAppReportNew);
    constructor(obj?: any) {
        this.unitId = obj?.unitId || "";
        this.appReportTemplateId = obj?.appReportTemplateId || "";
        this.units = Base.getTypedArray(obj?.units, IdTitleNode);
        this.allAllowedUnits = Base.getTypedArray(obj?.allAllowedUnits, IdTitleNode);
        this.appReportTemplates = Base.getTypedArray(obj?.appReportTemplates, AppReportTemplateEditItem);
    }
}